<template>
  <actionable-panel
    header-text="Confirm shipping"
    :complete="complete"
    :active="active"
    :current-step="currentStep"
    :total-steps="totalSteps"
    :disable-edit="editDisabled"
    @edit="transitionEdit"
  >
    <div class="wro-actionable-panel__body">
      <select-label v-if="isShipbobLabelSelected && !isDangerousGoodsPresent" />
      <estimated-arrival-date v-else v-model="estimatedArrivalDate" />
    </div>
    <sb-panel v-if="enableBOL && !isShipbobLabelSelected" slot="info" class="wro-actionable-panel__info-panel" type="sub">
      <h4 class="wro-actionable-panel__info-panel-title">
        Heads up!
      </h4>
      <p class="wro-actionable-panel__info-panel-note">
        Tip! Always add tracking numbers after you finish creating the WRO.
      </p>
      <p class="wro-actionable-panel__info-panel-note">
        If you're sending by freight, please let us know the arrival date or you may experience delays.
      </p>
      <p v-if="!isPoweredBySubAccountUser" class="wro-actionable-panel__info-panel-note">
        Need help with freight? Book your freight with our partner
        <help-center-link link-key="createWro/freightPartner">
          Freightos
        </help-center-link>.
      </p>
    </sb-panel>
    <sb-panel v-else-if="!isShipbobLabelSelected || showHeadsUpPanel" slot="info" class="wro-actionable-panel__info-panel" type="sub">
      <h4 class="wro-actionable-panel__info-panel-title">
        Heads up!
      </h4>
      <p class="wro-actionable-panel__info-panel-note">
        Tip! Remember to always add tracking numbers to the Summary View, once you've completed the form.
      </p>
    </sb-panel>
    <div slot="footer" class="wro-actionable-panel__footer">
      <sb-async-button :loading-promise="savingWro" :disabled="disableSave" class="wro-save-button wro-actionable-panel__action" @click="transitionSave">
        Save & Continue
      </sb-async-button>
      <a class="wro-actionable-panel__action" href="#" @click.prevent="transitionClear">Cancel</a>
    </div>
  </actionable-panel>
</template>

<script>
import stepsMixin from './stepsMixin'
import EstimatedArrivalDate from '../helpers/EstimatedArrivalDate.vue'
import SelectLabel from '../helpers/SelectLabel.vue'

export default {
  name: 'ArrivalDetails',
  inject: ['isPoweredBySubAccountUser'],
  components: {
    EstimatedArrivalDate,
    SelectLabel
  },
  directives: {},
  mixins: [stepsMixin],
  props: {},
  data: () => ({
    showHeadsUpPanel: false
  }),
  computed: {
    packagingType () {
      return this.draft ? this.draft.packagingType || {} : {}
    },
    enableBOL () {
      return this.packagingType && (this.packagingType.id === 2 || this.packagingType.id === 3)
    },
    estimatedArrivalDate () {
      return this.$shipBobStore.getters[this.StoreModuleName + '/estimatedArrivalDate']
    },
    pricingGroup () {
      return this.$shipBobStore.getters[this.StoreModuleName + '/pricingGroup']
    }
  },
  watch: {
    estimatedArrivalDate: {
      handler (n, o) {
        if (n) this.machine.transition('VALIDATE')
        else if (!this.pricingGroup || !this.pricingGroup.id) this.machine.transition('BAD')
      }
    },
    pricingGroup: {
      handler (n, o) {
        if (this.pricingGroup && this.pricingGroup.id) {
          this.showHeadsUpPanel = false
          this.transitionInput()
        } else {
          this.showHeadsUpPanel = true
          this.machine.transition('BAD')
        }
      }
    }
  },
  mounted () {},
  destroyed () {},
  methods: {},
  i18n: { messages: {} }
}
</script>

<style scoped lang='scss'>
  @import './panel.scss';
  .wro-confirm-shipping {
    margin-bottom: 2em;
    &:last-of-type {
      margin-bottom: 0;
    }
    &__block-title {
      color: #4e5c73;
      margin: 0;
      &--space-bottom {
        margin-bottom: 1em;
      }
    }
    &__address {
      color: #727a87;
    }
    &__address-line {
      margin: 0;
    }
    &__date-picker {
      display: inline-flex;
      align-items: center;
      color: #2470af;
    }
    &__date-picker-input {
      border: none !important;
    }
    &__date-picker-icon {
      cursor: pointer;
      margin-left: 0.5em;
      margin-bottom: 0;
    }
    &__file-upload-link-container {
      display: inline-flex;
      align-items: center;
      margin: 0;
      margin-top: 1em;
      max-width: 100%;
    }
    &__file-upload-link {
      color: #2470af;
      font-weight: 600;
      cursor: pointer;
    }
    &__file-upload-link-icon {
      margin-right: 0.5em;
      font-size: 1.25em;
    }
    &__file-upload-link-text {
      margin: 0;
    }
  }
</style>
